// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2VKt1","savePackageButton":"ClientWallet_savePackageButton__3JDrz"};